<template>
    <div class="w-full">
        <form class="flex flex-col lg:inline-flex lg:flex-row justify-center w-full">
            <input type="text" name="search_term" v-bind:placeholder="`${placeHolder}`" class="lg:w-1/3 w-full lg:text-3xl text-xl py-4 rounded outline-none text-center">
            <div class="lg:w-2/3 w-full pl-3 lg:inline-flex lg:flex-row flex flex-col items-center justify-end mt-3">
                <div class="lg:hidden">
                    <p class="mb-3 underline" ref="expand" v-on:click="expandFilters">[+] Expand</p>
                </div>
                <div ref="filters" class="hidden lg:block">
                    <div v-for="(input, index) in inputs" :key="index" class="lg:inline-flex lg:flex-row flex flex-col hidden items-center pl-3">
                        <input v-bind:type="`${input.type}`" v-bind:name="`${input.name}`" v-bind:value="`${input.value}`" v-bind:id="`${input.id}`" class="pl-3 mb-3">
                        <label v-bind:for="`${input.id}`" class="lg:text-2xl pr-3 mb-3 lg:mb-0">
                            {{ input.label }}
                        </label>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
  name: 'SearchBar',
  props: {
    placeHolder: String,
    inputs: Array
  },
  methods: {
    expandFilters: function () {
      this.$refs.filters.classList.toggle('hidden')
      if (this.$refs.filters.classList.contains('hidden')) {
        this.$refs.expand.innerHTML = '[+] Expand'
      } else {
        this.$refs.expand.innerHTML = '[-] Close'
      }
    }
  }
}
</script>

<style scoped>
    input[type=checkbox]{
        display: none;
    }

    input[type=checkbox] + label::after {
        border: 2px solid grey;
        width: 20px;
        height: 20px;
        content: '';
    }

    input[type=checkbox] + label:checked::after {
        content: "✓";
        color: white;
        background: dodgerblue;
        border: 1px solid dodgerblue;
    }
</style>
